import { Injectable } from "@angular/core";

@Injectable()
export class SleepService {
	static async sleep(timeout: number = 0): Promise<void> {
		return new Promise<void>((resolve) => setTimeout(() => resolve(), timeout));
	}
}

